/*
  Omnify Cart CRO: toevoegknoppen in de cart drawer (Rain Cover upsell en de strollers in de lege cart).
  Voegt het product toe via de Shopify Ajax API en laat de bestaande Dawn cart drawer zichzelf opnieuw renderen,
  op dezelfde manier als Dawn's product-form.js dat doet (inclusief het verwijderen van 'is-empty').

  Markup:
  <cart-upsell data-variant-id="123">
    <button data-cro-add>
      <span data-cro-label>...</span>
      <span data-cro-loading hidden>...</span>
    </button>
    <p data-cro-error hidden></p>
  </cart-upsell>
*/
if (!customElements.get('cart-upsell')) {
  class CartUpsell extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-cro-add]');
      this.label = this.querySelector('[data-cro-label]');
      this.loading = this.querySelector('[data-cro-loading]');
      this.error = this.querySelector('[data-cro-error]');
      if (!this.button || this.dataset.bound) return;
      this.dataset.bound = 'true';
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.add();
      });
    }

    setLoading(isLoading) {
      this.button.disabled = isLoading;
      this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (this.label) this.label.hidden = isLoading;
      if (this.loading) this.loading.hidden = !isLoading;
    }

    async add() {
      const drawer = document.querySelector('cart-drawer');
      const addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];

      if (this.error) this.error.hidden = true;
      this.setLoading(true);

      try {
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Toevoegen lukte niet');
        }

        if (drawer && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (e) {
        this.setLoading(false);
        if (this.error) {
          this.error.textContent = 'Dat lukte even niet. Probeer het nog een keer.';
          this.error.hidden = false;
        }
      }
    }
  }

  customElements.define('cart-upsell', CartUpsell);
}
